// SortControls-redesign.js
import React from 'react';
import { ArrowUpDown } from 'lucide-react';

const SortControls = ({ currentSort, onSortChange }) => {
  const sortOptions = [
    { 
      id: 'clinical-importance', 
      label: 'Harmful First',
      icon: '⚠️'
    },
    { 
      id: 'clinical-importance-reverse', 
      label: 'Beneficial First',
      icon: '✅'
    },
    { 
      id: 'gwas-risk', 
      label: 'GWAS Risk',
      icon: '📊'
    },
    { 
      id: 'gene', 
      label: 'Gene A-Z',
      icon: '🔤'
    },
    { 
      id: 'chromosome', 
      label: 'Position',
      icon: '🧬'
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-200 bg-slate-50">
        <ArrowUpDown className="w-4 h-4 text-indigo-600 flex-shrink-0" />
        <h3 className="text-sm font-bold text-slate-900">Sort</h3>
      </div>

      <div className="p-3">
        <div className="grid grid-cols-2 gap-2">
          {sortOptions.map(option => (
            <button
              key={option.id}
              onClick={() => onSortChange(option.id)}
              className={`
                px-2 py-2 rounded-lg text-xs font-semibold transition-all border text-left
                ${currentSort === option.id 
                  ? 'bg-indigo-600 text-white border-indigo-700 shadow-sm' 
                  : 'bg-slate-50 text-slate-700 border-slate-200 hover:bg-slate-100'
                }
              `}
            >
              <div className="flex flex-col items-center text-center gap-0.5">
                <span className="text-base">{option.icon}</span>
                <span className="text-xs leading-tight">{option.label}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SortControls;